import { Link } from 'react-router-dom';

function TickerRow({ row, onHighlight, isHighlighted }) {
  const href = row.icao24 ? `/a/${row.icao24}` : null;
  const inner = (
    <>
      <span className="ticker-ts">{row.timeLabel}</span>
      <span className="ticker-body">
        <span className="ticker-id">{row.label}</span> {row.eventType?.replace(/_/g, ' ') || 'flying'} · {row.region}
      </span>
      {Number.isFinite(row.altFt) && <span className="ticker-alt">{row.altFt.toLocaleString()} ft</span>}
    </>
  );
  const className = `ticker-row${isHighlighted ? ' is-highlighted' : ''}`;
  return href ? (
    <Link
      to={href}
      className={className}
      onMouseEnter={() => onHighlight?.(row.icao24)}
      onMouseLeave={() => onHighlight?.(null)}
    >
      {inner}
    </Link>
  ) : (
    <div
      className={className}
      onMouseEnter={() => onHighlight?.(row.icao24)}
      onMouseLeave={() => onHighlight?.(null)}
    >
      {inner}
    </div>
  );
}

export default TickerRow;
